import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-primary-button',
  templateUrl: './primary-button.component.html',
  styleUrls: ['./primary-button.component.css']
})
export class PrimaryButtonComponent {

  @Input() text: string;
  @Input() icon: string;
  @Input() buttonText: string;
  @Input() disabled: boolean;


  constructor() { }


}
